import { useQuery } from 'react-query';
import ProfileProgress from '../../services/ProfileProgress';
import { PROFILE_PROGRESS } from '../../constants/reactQuery.keys';

export function useProfileProgress() {
  return useQuery([PROFILE_PROGRESS], () => ProfileProgress.getProfileProgress(), { refetchOnWindowFocus: false });
}
